// src/components/subscription/SubscriptionSuccessPage.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const subscription = useSelector((s) => s.subscription.subscription);

  const handleViewPlans = () => {
    navigate('/membershipPlans');
  };

  if (!subscription) {
    // If someone lands here without a subscription, redirect
    navigate('/membershipPlans');
    return null;
  }

  const { planName, packageType, remainingDays } = subscription;
  const prettyPackage = packageType.replace(/_/g, ' ');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary-shade1 p-6 font-nunito">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center space-y-6">
        <CheckCircle2 className="mx-auto text-green-500" size={64} />
        <h1 className="text-3xl font-bold text-text-black">
          Subscription Successful!
        </h1>
        <p className="text-text-muted">
          You’re now on the <span className="font-semibold">{planName}</span> plan,
          <br />
          <span className="font-semibold">{prettyPackage}</span> package.
        </p>
        <p className="text-text-muted">
          Days remaining: <span className="text-primary font-semibold">{remainingDays}</span>
        </p>
        <button
          onClick={handleViewPlans}
          className="mt-4 inline-flex items-center gap-2 bg-primary to-primary-shade4 text-white px-6 py-2 rounded-full font-medium shadow-md hover:scale-105 transition-transform"
        >
          View All Plans
        </button>
      </div>
    </div>
  );
}
